import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    AppBar,
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    CircularProgress,
    Grid2 as Grid,
    IconButton,
    InputAdornment,
    TextField,
    Toolbar,
    Tooltip,
    Typography,
} from '@mui/material';
import { AccountCircle, Add, ArrowBack, ArrowForward, Backspace, Cancel, Check, CleanHands, ClearAll, Close, Delete, Download, Edit, FilterAlt, Info, Menu, Message, PictureAsPdf, PictureAsPdfOutlined, PlayArrow, QrCode, Search } from '@mui/icons-material';
import { checkComponentPresence, getMyDate, getSelectedElement, myFormat, myTimestampToDate, propComparator } from "../utils/ui_utils";

import { CowmanDialog } from "../modals/CowmanDialog";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { add_Cowman, clear_all_cowmans, delete_Cowman, edit_Cowman, get_Cowman_list } from "../FirebaseUtils/dbCowman";
import { useEvent } from "../context/eventContext";
import { useAuth } from "../core/AuthProvider";
import { globalstyles } from "../lib/definitions";
import { differenceInMonths } from "date-fns";
import { memo } from "react";
import { PlaceSection } from "../components/PlaceSection";
import { NavigationButtons } from "../components/NavigationButtons";
import { get_cowman_stat } from "../FirebaseUtils/dbCow";
import { PresenceSummaryStats } from "../components/PresenceButton";
import { SortButton } from "../components/SortButton";
import { ContainerPdfDialog } from "../modals/PdfContainerDialog";
import ElevationScroll from "../components/ElevationScroll";

const PAGE_COUNT =50 


export default function CowmanListPage() {
    const dialogRef = useRef()
    const pdfDialog = useRef()
    const childRefDelete = useRef()
    const { user } = useAuth()
    const { selEvent } = useEvent()
    const [element_list, setElementList] = useState([])
    const [filtered_element_list, setFilteredElementList] = useState([])
    const [cur_session, setCurrentSession] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [showSearch, setShowSearch] = useState(false)
    const [showFilter, setShowFilter] = useState(false)
    const [filterApplied, setFilterApplied] = useState({})
    const [search_text, setSearchText] = useState('')
    const [isSubLoading, setIsSubLoading] = useState(true)
    const cowman_data = useRef({})

    const [view_list, setViewList] = useState({ last_index: -1, list: [], cur_page: 0 })
    const [sortProp, setSortProp] = useState({ sortparam: 'name', sortdirection: 1 })

    const handleNew = () => {
        dialogRef.current.onNew()
    }

    useEffect(() => {
        if (search_text.length > 0) {
            setFilteredElementList(
                element_list.filter(c =>
                    (filterApplied.show_not_present === true || c.present !== false)
                    && (!filterApplied.show_type || c.cowman_type === filterApplied.show_type)
                    && ((c.catalog_id && String(c.catalog_id).includes(search_text))
                        || c.name.toLowerCase().includes(search_text))
                    //    || c.serial.toLowerCase().includes(search_text)
                ))
        } else {
            setFilteredElementList(
                element_list.filter(c =>
                    (filterApplied.show_present === true || c.present !== false)
                    && (!filterApplied.show_type || c.cowman_type === filterApplied.show_type)

                    //    || c.serial.toLowerCase().includes(search_text)
                ))
        }

    }, [search_text, filterApplied])

    useEffect(() => {
        setIsSubLoading(true)
        setElementList(el => {
            let _el = [...el]
            if (sortProp?.sortparam === 'subject') {
            } else {
                _el.sort(propComparator(sortProp.sortparam))
            }
            if (sortProp.sortdirection < 0) {
                _el.reverse()
            }
            return _el
        })
    }, [sortProp])


    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }



    const handleDelete = (r, i, p) => {
        console.log("DELETE", r, i)
        const cb = () => {
            delete_Cowman(selEvent.id, r.id)
            setElementList(lst => {
                let _el = [...lst]
                _el.splice(i, 1)
                return _el
            })
        }
        childRefDelete.current.confirmDelete('Cancella allevatore', `Sei sicuro di voler cancellare l'allevatore: <b>${r.name}</b>`, cb)
    }


    const addFn = async (el) => {
        const res = await add_Cowman(user.uid, selEvent.id, el)
        reloadFn()
    }

    const editFn = async (el) => {
        const res = await edit_Cowman(user.uid, selEvent.id, el.id, el)
        reloadFn(el)
    }

    const reloadFn = async (el) => {
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                }
                return _el
            })


        } else {
            setIsLoading(true)
            const data = await get_Cowman_list(selEvent.id)
            const _sort_data = data.sort(propComparator('name'))

            setElementList(_sort_data)

        }
    }


    const goPrevPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page - 1 }))
    }


    const goNextPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page + 1 }))
    }



    const handleCleanData = () => {
        const cb = async () => {
            setIsLoading(true)
            const res = await clear_all_cowmans(selEvent.id)
            console.log("RES", res)
            setElementList([])
        }
        childRefDelete.current.confirmDelete('Cancella tutti gli allevatori ', `Sei sicuro di voler cancellare <b>TUTTI GLI ALLEVATORI</b>? <br/> quest'azione non è annullabile`, cb)
    }


    useEffect(() => {
        console.log(selEvent.id)
        if (selEvent && selEvent.id) {

            reloadFn()
        }

    }, [selEvent])



    const handleShowPdf = (t) => {
        console.log(cowman_data)
        pdfDialog.current.onOpen({ cowman_list: element_list, cowman_data: cowman_data.current || {} }, 'elenco allevatori', 'cowman')
    }


    const refreshData = (c_id, data) => {
        cowman_data.current[c_id] = data
    }

    useEffect(() => {
        let _view_list = []
        console.log("DO SET VIEW", filtered_element_list.length)
        if (filtered_element_list.length > 0) {
            for (let i = 0; i < filtered_element_list.length; i += PAGE_COUNT) {
                const chunk = filtered_element_list.slice(i, i + PAGE_COUNT);
                _view_list.push(chunk)
            }
        }
        if (view_list.cur_page < view_list.list?.length) {
            setViewList(v => ({ ...v, list: _view_list }))
        } else {
            setViewList({ list: _view_list, cur_page: 0 })
        }
        setIsLoading(false)
    }, [filtered_element_list])

    useEffect(() => {
        console.log("DO SET FILTER")
        setFilteredElementList(element_list)

    }, [element_list])


    useEffect(() => {
        console.log("AFTER SET", cur_session)

    }, [cur_session])

    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>
            <DeleteconfirmationSection ref={childRefDelete} />
            <CowmanDialog ref={dialogRef} addFn={addFn} editFn={editFn} />
            <ContainerPdfDialog ref={pdfDialog} />
            <ElevationScroll>
                <AppBar style={globalstyles.secondaryAppBar}>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold', textAlign: 'left' }}>
                            Lista Allevatori <Chip size="small" label={<>{filtered_element_list.length !== element_list.length ? <>{filtered_element_list.length}/</> : ''}{element_list.length}</>} />
                        </Grid>
                        <Grid size={"auto"} sx={{ textAlign: 'right' }}>
                            <ButtonGroup size="small">
                                {element_list.length > 0 &&
                                    <Button onClick={handleCleanData} variant="outlined" color="error" size="small" startIcon={<Backspace />}>Rimuovi tutti gli allevatori</Button>
                                }
                                <Button onClick={handleShowPdf} variant="outlined" color="secondary" size="small" startIcon={<PictureAsPdfOutlined />}>Pdf</Button>
                                <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo allevatore</Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    {view_list.list[view_list.cur_page]?.length > 0 ?
                        <>
                            <Grid container sx={globalstyles.listHeader}>
                                <Grid size={1} container sx={{ justifyContent: "center" }}>
                                    <Grid>
                                        Codice AUA
                                    </Grid>
                                    <Grid>
                                        <SortButton setSortProp={setSortProp} p={'cdaua_cowman'} sortProp={sortProp} />
                                    </Grid>
                                </Grid>
                                <Grid size={"grow"} container sx={{ justifyContent: "center" }}>
                                    <Grid>
                                        Nome
                                    </Grid>
                                    <Grid>
                                        <SortButton setSortProp={setSortProp} p={'name'} sortProp={sortProp} />
                                    </Grid>
                                </Grid>
                                <Grid size={3} container sx={{ justifyContent: "center" }}>
                                    <Grid>
                                        Località
                                    </Grid>
                                    <Grid>
                                        <SortButton setSortProp={setSortProp} p={'comune'} sortProp={sortProp} />
                                    </Grid>
                                </Grid>
                                <Grid size={3} sx={{ textAlign: 'right' }}>
                                    <NavigationButtons view_list={view_list} goNextPage={goNextPage} goPrevPage={goPrevPage} />
                                </Grid>

                            </Grid>

                        </>
                        :
                        <Grid >
                        </Grid>
                    }
                </AppBar>
            </ElevationScroll>
            <Toolbar style={{marginBottom: '15px'}} />
            {isLoading ?
                <CircularProgress />
                :
                <>


                    {view_list.list[view_list.cur_page]?.length > 0 ?
                            <Grid >
                                {view_list.list[view_list.cur_page].map((cowman, k) => (
                                    <OneCowman
                                        key={k}
                                        refreshData={refreshData}
                                        cowman={cowman}
                                        index={k + (PAGE_COUNT * view_list.cur_page)}
                                        handleEdit={() => handleEdit(cowman, k + (PAGE_COUNT * view_list.cur_page))}
                                        handleDelete={(p) => handleDelete(cowman, k + (PAGE_COUNT * view_list.cur_page), p)}
                                    />
                                ))}
                            </Grid>
                        :
                        <Grid >
                            {element_list.length === 0 ?
                                <Typography sx={globalstyles.missing_value}>
                                    Nessun allevatore ancora inserito
                                </Typography>
                                :
                                <>
                                    Nessun allevatore trovato con i filtri applicati
                                </>
                            }
                        </Grid>
                    }
                </>
            }

        </Box >
    );
}





const OneCowman = memo(({ cowman, index, handleDelete, handleEdit, refreshData }) => {


    const { selEvent } = useEvent()
    const [stat_data, setStatData] = useState({})

    useEffect(() => {
        setStatData({})
        const initData = async () => {
            const d = await get_cowman_stat(selEvent.id, cowman.id)
            console.log(d)
            refreshData(cowman.id, d)
            setStatData(d)
        }
        initData()

    }, [cowman])

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.8em', backgroundColor: cowman.present === false ? '#c18989' : '' }}>
            <Grid size={1}>
                {cowman.cdaua_cowman}
            </Grid>
            <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                {cowman.name}
            </Grid>
            <Grid size={3}>
                <PlaceSection data={cowman} />
            </Grid>
            <Grid size={2}>
                <PresenceSummaryStats key={index} stat_data={stat_data} />
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
                <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={() => handleEdit(cowman, index)} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <Button color="error" onClick={handleDelete} startIcon={<Delete />}></Button>
                    </Tooltip>
                </ButtonGroup>
            </Grid>
        </Grid>

    )
})





